module.exports = __webpack_public_path__ + "img/pictile-banner.0a00d6f5.jpg";